__turbopack_context__.v({
  "actionIcon": "Events-module-scss-module__C4Pkja__actionIcon",
  "addingParticipantsByFullNamesModal": "Events-module-scss-module__C4Pkja__addingParticipantsByFullNamesModal",
  "bannerContainer": "Events-module-scss-module__C4Pkja__bannerContainer",
  "bannerTitle": "Events-module-scss-module__C4Pkja__bannerTitle",
  "cardIcon": "Events-module-scss-module__C4Pkja__cardIcon",
  "chevronIcon": "Events-module-scss-module__C4Pkja__chevronIcon",
  "container": "Events-module-scss-module__C4Pkja__container",
  "eventCard": "Events-module-scss-module__C4Pkja__eventCard",
  "eventDetailsCardText": "Events-module-scss-module__C4Pkja__eventDetailsCardText",
  "eventDetailsCardTitle": "Events-module-scss-module__C4Pkja__eventDetailsCardTitle",
  "eventLink": "Events-module-scss-module__C4Pkja__eventLink",
  "eventPeople": "Events-module-scss-module__C4Pkja__eventPeople",
  "loadMore": "Events-module-scss-module__C4Pkja__loadMore",
  "title": "Events-module-scss-module__C4Pkja__title",
});
